function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import GroupIcon from "@mui/icons-material/Group";
import CloseIcon from "@mui/icons-material/Close";
import Alert from "@mui/material/Alert";
import UserAvatar from "../../../../components/mui/material/UserAvatar";
import GroupAvatar from "../../../../components/mui/material/GroupAvatar";
import { useColumnVisibilityContext } from "../../contexts/ColumnVisibilityContext";
import { useCurrentGroupContext } from "../../contexts/CurrentGroupContext";
import { hasRole, roleIds } from "../../../../constants";
import AddGroupMembersDialog from "./AddGroupMembersDialog";
import GroupMemberListItem from "./GroupMemberListItem";
var tKey = "features.Chat.Actions";
function Actions(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useColumnVisibilityC = useColumnVisibilityContext(),
    hideRightColumn = _useColumnVisibilityC.hideRightColumn;
  var _useCurrentGroupConte = useCurrentGroupContext(),
    currentGroup = _useCurrentGroupConte.currentGroup;
  var authUserId = useSelector(function (state) {
    return state.authentication.userId;
  });
  var authUser = useSelector(function (state) {
    return state.entities.users.byId[authUserId];
  });
  var authUserMember = currentGroup && currentGroup.members.find(function (member) {
    return member.user.id === authUserId;
  });
  var otherMember = currentGroup && !currentGroup.multi && currentGroup.members.find(function (member) {
    return member.user.id !== authUser.id;
  });
  var otherMembers = currentGroup && currentGroup.multi && currentGroup.members.filter(function (member) {
    return member.user.id !== authUser.id;
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showGroupMembersCollapse = _useState2[0],
    setShowGroupMembersCollapse = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    addGroupMembersOpen = _useState4[0],
    setAddGroupMembersOpen = _useState4[1];
  function toggleShowGroupMembers() {
    setShowGroupMembersCollapse(!showGroupMembersCollapse);
  }
  function toggleAddGroupMembers() {
    setAddGroupMembersOpen(!addGroupMembersOpen);
  }
  var forwardProps = function (_ref) {
    var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
    return rest;
  }(props);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, forwardProps, /*#__PURE__*/React.createElement(AppBar, {
    sx: {
      position: "relative"
    }
  }, /*#__PURE__*/React.createElement(Toolbar, null, /*#__PURE__*/React.createElement(IconButton, {
    edge: "start",
    color: "inherit",
    onClick: hideRightColumn,
    "aria-label": "close"
  }, /*#__PURE__*/React.createElement(CloseIcon, null)), /*#__PURE__*/React.createElement(Typography, {
    sx: {
      ml: 2,
      flex: 1
    }
  }, currentGroup.multi ? t("".concat(tKey, ".groupInfo")) : t("".concat(tKey, ".contactInfo"))))), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    sx: {
      position: "relative",
      height: "100%",
      width: "100%",
      overflow: "auto",
      scrollbarColor: "rgba(255, 255, 255, .16) transparent",
      scrollbarWidth: "thin"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "border-bottom p-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center"
  }, currentGroup.multi ? /*#__PURE__*/React.createElement(GroupAvatar, {
    size: "xl",
    group: currentGroup
  }) : /*#__PURE__*/React.createElement(UserAvatar, {
    size: "xl",
    user: otherMember.user
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center mt-3"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 600
    }
  }, currentGroup.multi ? currentGroup.name || otherMembers.map(function (member) {
    return member.user.fullName;
  }).join(", ") : otherMember.user.fullName)), currentGroup.multi && /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-center mt-3"
  }, t("".concat(tKey, ".group")), "\xA0\xB7\xA0", t("".concat(tKey, ".membersCount"), {
    membersCount: currentGroup.members.length
  }))), currentGroup.members.some(function (member) {
    return member.user.type === "AiUser";
  }) && /*#__PURE__*/React.createElement("div", {
    className: "border-bottom"
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    sx: {
      alignItems: "center",
      borderRadius: 0
    }
  }, t("".concat(tKey, ".aiMakeMistakes")))), /*#__PURE__*/React.createElement("div", {
    className: "border-bottom p-4"
  }, /*#__PURE__*/React.createElement("span", null, currentGroup.multi ? currentGroup.description : otherMember.user.bio)), currentGroup.multi && /*#__PURE__*/React.createElement(List, {
    component: "nav"
  }, hasRole(authUserMember, roleIds.ADMIN) && /*#__PURE__*/React.createElement(ListItemButton, {
    onClick: toggleAddGroupMembers
  }, /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(GroupAddIcon, null)), /*#__PURE__*/React.createElement(ListItemText, {
    primary: "Add user to group"
  })), /*#__PURE__*/React.createElement(ListItemButton, {
    onClick: toggleShowGroupMembers
  }, /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(GroupIcon, null)), /*#__PURE__*/React.createElement(ListItemText, {
    primary: t("".concat(tKey, ".members"))
  }), showGroupMembersCollapse ? /*#__PURE__*/React.createElement(ExpandLessIcon, null) : /*#__PURE__*/React.createElement(ExpandMoreIcon, null)), /*#__PURE__*/React.createElement(Collapse, {
    in: showGroupMembersCollapse
  }, /*#__PURE__*/React.createElement(List, {
    component: "div",
    disablePadding: true
  }, currentGroup.members.map(function (member, i) {
    return /*#__PURE__*/React.createElement(GroupMemberListItem, {
      key: i,
      groupMember: member
    });
  })))))), /*#__PURE__*/React.createElement(AddGroupMembersDialog, {
    open: addGroupMembersOpen,
    onClose: toggleAddGroupMembers
  }));
}
export default Actions;